import React, { useState, useEffect } from 'react';
import './LandingCarousel.css';

interface CarouselImage {
  url: string;
  text: string;
}

interface LandingCarouselProps {
  onNavigate?: (page: string) => void;
}

const LandingCarousel: React.FC<LandingCarouselProps> = ({ onNavigate }) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const images: CarouselImage[] = [
    {
      url: '/images/general/seminar-demonstration.jpg',
      text: 'ITF Traditional Taekwon-Do — Training, Competition & Self Defence'
    },
    {
      url: '/images/general/training-class-squats.jpg',
      text: 'Build Strength, Discipline & Confidence'
    },
    {
      url: '/images/general/competition-group.jpg',
      text: 'Master Your Mind, Body & Spirit'
    }
  ];

  const changeImageEveryXMs = 6000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, changeImageEveryXMs); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index: number): void => {
    setCurrentIndex(index);
  };

  return (
    <div className="landing-carousel">
      <div className="carousel-container">
        {images.map((image, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image.url})` }}
          >
            <div className="carousel-overlay"></div>
            <div className="carousel-text">
              <h1>{image.text}</h1>
              {onNavigate && (
                <button
                  className="carousel-cta-button"
                  onClick={() => onNavigate('about-our-club')}
                >
                  Learn More About Our Club
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="carousel-indicators">
        {images.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default LandingCarousel;

